import React from 'react';

import {Helmet, useParams} from 'views/module';

import CaseScene from 'views/scenes/case/CaseScene';

const CasePage = (props) => {
  const params = useParams();
  const caseRn = params.caseRn;

  return (
    <>
      <Helmet>
        <title>Quilt: Case</title>
      </Helmet>
      <CaseScene key={caseRn} caseRn={caseRn} />
    </>
  );
};

export default CasePage;
